import React from "react"
import "./src/styles/fonts.css"
import { ScrollPositionProvider } from "./src/contexts"

export const wrapRootElement = ({ element }) => (
  <ScrollPositionProvider>{element}</ScrollPositionProvider>
)
